import { Dialog, DialogTitle, DialogContent, DialogActions, Divider } from "@mui/material";
import VuiBox from "components/VuiBox";
import VuiTypography from "components/VuiTypography";
import VuiButton from "components/VuiButton";
import { FaTrash, FaExclamationTriangle } from "react-icons/fa";
import useCommon from "hooks/useCommon";

const DeleteRoleDialog = ({ open, role, onClose, onConfirm }) => {
  if (!role) return null;

  const { STORE } = useCommon();
  const { deleteLoading } = STORE((state) => state.roles);

  const userCount = role.userCount || role.users?.length || 0;
  const canDelete = userCount === 0;

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogContent>
        <VuiBox textAlign="center" py={1}>
          <FaExclamationTriangle size={32} color={canDelete ? "#ff4d4f" : "#faad14"} />

          <VuiTypography variant="body2" fontWeight="medium" mt={2}>
            {canDelete
              ? `Are you sure you want to delete the role "${role.title}"?`
              : `The role "${role.title}" cannot be deleted.`}
          </VuiTypography>

          <VuiTypography variant="caption" mt={1}>
            {canDelete ? (
              "This action is permanent and cannot be undone."
            ) : (
              <>
                This role is currently assigned to <strong>{userCount}</strong> user
                {userCount > 1 ? "s" : ""}.
                <br />
                Please reassign or remove those users before deleting this role.
              </>
            )}
          </VuiTypography>
        </VuiBox>
      </DialogContent>

      <DialogActions>
        <VuiButton variant="outlined" color="primary" onClick={onClose}>
          Close
        </VuiButton>

        {canDelete && (
          <VuiButton
            variant="contained"
            color="error"
            startIcon={<FaTrash />}
            onClick={() => onConfirm(role)}
            disabled={deleteLoading}
          >
            {deleteLoading ? "Deleting..." : " Delete Role"}
          </VuiButton>
        )}
      </DialogActions>
    </Dialog>
  );
};

export default DeleteRoleDialog;
